import { Fee } from '../FeesCard/FeesCard';
import { CostRange } from '../TournamentDetails.types';

export type BuildFeesParams = {
  cost?: CostRange;
  costLabel?: string;
  teamFeeEnabled?: boolean;
  teamPlayerFeeEnabled?: boolean;
  teamPlayerFeeAmount?: CostRange;
  freeAgentPlayerFeeEnabled?: boolean;
  freeAgentPlayerFeeAmount?: CostRange;
  teamStaffMemberFeeEnabled?: boolean;
  teamStaffMemberFeeAmount?: CostRange;
  freeAgentStaffMemberFeeEnabled?: boolean;
  freeAgentStaffMemberFeeAmount?: CostRange;
};

export function buildFees(params: BuildFeesParams): Fee[] {
  const {
    cost,
    costLabel,
    freeAgentPlayerFeeAmount,
    freeAgentPlayerFeeEnabled,
    freeAgentStaffMemberFeeAmount,
    freeAgentStaffMemberFeeEnabled,
    teamFeeEnabled,
    teamPlayerFeeAmount,
    teamPlayerFeeEnabled,
    teamStaffMemberFeeAmount,
    teamStaffMemberFeeEnabled,
  } = params;

  const fees: Fee[] = [];

  if (teamFeeEnabled && cost) {
    fees.push({ label: costLabel ?? 'Team', ...cost });
  }
  if (teamPlayerFeeEnabled && teamPlayerFeeAmount) {
    fees.push({ label: 'Team Player', ...teamPlayerFeeAmount });
  }
  if (freeAgentPlayerFeeEnabled && freeAgentPlayerFeeAmount) {
    fees.push({ label: 'Free Agent Player', ...freeAgentPlayerFeeAmount });
  }
  if (teamStaffMemberFeeEnabled && teamStaffMemberFeeAmount) {
    fees.push({ label: 'Team Staff Member', ...teamStaffMemberFeeAmount });
  }
  if (freeAgentStaffMemberFeeEnabled && freeAgentStaffMemberFeeAmount) {
    fees.push({
      label: 'Free Agent Staff Member',
      ...freeAgentStaffMemberFeeAmount,
    });
  }

  return fees;
}
